import React, { ReactElement } from 'react'

import { NotifyContainer } from '@instabox/internal-web-ui/utils/notify'
import { Switch, Route, Redirect, HashRouter } from 'react-router-dom'

import styles from './App.module.scss'
import Baseline from './views/baseline/Baseline'
import PrivateRoute from './views/components/PrivateRoute'
import TopNavbar from './views/components/TopBar'
import CurrentRollout from './views/CurrentRollout'
import Device from './views/Device'
import Devices from './views/devices/Devices'
import Package from './views/gemfury/Package'
import Packages from './views/gemfury/Packages'
import PackageVersion from './views/gemfury/PackageVersion'
import Login from './views/Login'
import NewRollout from './views/rollout/Rollout'

function App(): ReactElement {
  return (
    <HashRouter>
      <NotifyContainer position="top-right" autoClose={5000} draggable={false} />
      <div>
        <TopNavbar />
        <main className={`${styles.main} container`}>
          <Switch>
            <Route exact path="/">
              <Redirect to="/login" />
            </Route>
            <Route exact path="/login">
              <Login />
            </Route>
            <PrivateRoute path="/baseline" component={Baseline} />
            <PrivateRoute path="/devices" component={Devices} />
            <PrivateRoute path="/device/:deviceId" component={Device} />
            <PrivateRoute path="/package/:packageId/:version" component={PackageVersion} />
            <PrivateRoute path="/package/:packageId" component={Package} />
            <PrivateRoute path="/package" component={Packages} />
            <PrivateRoute path="/rollout/manage" component={NewRollout} />
            <PrivateRoute path="/rollout" component={CurrentRollout} />
          </Switch>
        </main>
      </div>
    </HashRouter>
  )
}
export default App
